import { render, staticRenderFns } from "./Privacidad.vue?vue&type=template&id=5870ca51&scoped=true&"
import script from "./Privacidad.vue?vue&type=script&lang=js&"
export * from "./Privacidad.vue?vue&type=script&lang=js&"
import style0 from "./Privacidad.vue?vue&type=style&index=0&id=5870ca51&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5870ca51",
  null
  
)

export default component.exports